export const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const geocodeCity = async (cityName) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(cityName)}&format=json&limit=1`,
      { headers: { 'User-Agent': 'PeladaMatch/1.0' } }
    );
    const data = await res.json();
    if (data[0]) return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
  } catch (_e) {
    // silently ignore geocoding failures
  }
  return null;
};

// Remove sufixo " - UF" e normaliza para comparação
export const normalizeCity = (city) => {
  if (!city) return '';
  return city.replace(/\s*-\s*[A-Z]{2}$/, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
};
